<script setup lang="ts">
import dayjs from 'dayjs';

import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header2 from '@/components/base/typography/Header2.vue';

const grandKids = nutshell['static_img/about-us/grandkids.jpg'];
const dadAndUncleSandy = nutshell['static_img/about-us/dadandunclesandy.jpg'];

const yearsSince = dayjs().diff(dayjs('1929-01-01'), 'year');
</script>

<template>
  <div class="flex flex-col gap-4">
    <Header2>Our Story</Header2>
    <BaseBodyText class="mt-2">
      As mentioned above, the vision and determination of our Poppy Sol is what launched the Newark
      Nut Company.
    </BaseBodyText>

    <BaseBodyText>
      He began selling premium bulk nuts and dried fruit at the popular Mulberry Street open-air
      market. Sol quickly developed a reputation for providing the very finest and freshest nuts
      available. Sol believed in choosing only the highest quality super colossal nuts from the
      world's best growers. He would then roast the nuts to perfection for a fresh, delicious
      flavor.
    </BaseBodyText>

    <div class="p-4 text-center bg-nuts-neutral-100">
      <div class="text-center">
        <img
          alt="Cousins Jeff (left) and David in about 1984."
          class="align-middle"
          height="245"
          :src="grandKids"
          width="169"
        />
        <em class="block w-1/2 mx-auto mt-1 italic">
          Cousins Jeff (left) and David in about 1984.
        </em>
      </div>
      <div class="inline-block text-center">
        <img
          alt="Uncle Sandy on the left and Kenny on the right in 1954."
          height="245"
          :src="dadAndUncleSandy"
          width="137"
        />
        <em class="block w-1/2 mx-auto mt-1 italic">
          Uncle Sandy on the left and Kenny on the right in 1954.
        </em>
      </div>
    </div>

    <BaseBodyText>
      Now, {{ yearsSince }} years later, my cousin David and I represent the third generation of our
      family business. Although much has changed, our basic philosophy has not, and we continue the
      family tradition of providing the same superb quality and service as in the past. Our
      customers, some in their 80's and 90's, still rave about the splendid quality and luscious
      flavor of the products that have made our company famous throughout the years. A visit to the
      shop today will make your mouth water as the aroma of the freshly roasted peanuts and corn
      kernels popping tempt your taste buds. We love when customers come to our new location in
      Cranford to pick up orders and say hello. However, please keep in mind it is a warehouse
      location and you are unable to walk around and shop.
    </BaseBodyText>

    <BaseBodyText>
      In 1999, we launched NutsOnline to bring our savory selection of more than 2,000 items right
      to your door. By 2011, NutsOnline became pretty well known across North America for great
      quality and service across a growing product offering. Our slogan, "We're more than just
      nuts," continued to ring true.
    </BaseBodyText>

    <BaseBodyText>
      That being said, I can't tell you the number of times I would make new friends and, before
      saying goodbye, they would say, "I'm excited to check you guys out. Nuts.com, right?" Even
      Rachael Ray made this mistake on her show! So, in January 2012, we decided to officially
      change our nuts to Nuts.com. Despite the name change, we are still the same - the same family,
      the same values, the same quality, and the same level of care. We buy directly from growers,
      so whether you want one pound or 1,000 pounds, we will gladly accommodate any of your needs,
      including wholesale. You can order online through our secure server, over the phone, or via
      fax or e-mail.
    </BaseBodyText>

    <BaseBodyText>
      We roast our nuts and pop our corn the same day we ship so they reach you deliciously fresh as
      if you bought them from our shop. We do it the "Old Fashioned Way." One taste and you will
      know the difference. My grandfather began building our reputation back in 1929 and,
      {{ yearsSince }} years later, we continue to make sure that every product we sell is second to
      none. That's a promise. 100% satisfaction guaranteed!
    </BaseBodyText>

    <BaseBodyText>
      If you have any questions, comments, or suggestions, feel free to contact us!
    </BaseBodyText>

    <BaseBodyText>
      Thanks and enjoy!<br />
      - Jeffrey (third generation) along with my dad, Kenny, my uncle, Sandy, my cousin, David, and
      the rest of the Nuts.com Family!!
    </BaseBodyText>
  </div>
</template>
